import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
var selectOptionCss = ":host{display:none}";

var SelectOption = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SelectOption, _HTMLElement);

  var _super = _createSuper(SelectOption);

  function SelectOption() {
    var _this;

    _classCallCheck(this, SelectOption);

    _this = _super.call(this);

    _this.__registerHost();

    _this.__attachShadow();

    _this.inputId = "ion-selopt-".concat(selectOptionIds++);
    /**
     * If `true`, the user cannot interact with the select option. This property does not apply when `interface="action-sheet"` as `ion-action-sheet` does not allow for disabled buttons.
     */

    _this.disabled = false;
    return _this;
  }

  _createClass(SelectOption, [{
    key: "render",
    value: function render() {
      return h(Host, {
        role: "option",
        id: this.inputId,
        class: getIonMode(this)
      });
    }
  }, {
    key: "el",
    get: function get() {
      return this;
    }
  }], [{
    key: "style",
    get: function get() {
      return selectOptionCss;
    }
  }]);

  return SelectOption;
}(HTMLElement);

var selectOptionIds = 0;
SelectOption = /*@__PURE__*/proxyCustomElement(SelectOption, [1, "ion-select-option", {
  "disabled": [4],
  "value": [8]
}]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-select-option"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-select-option":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, SelectOption);
        }

        break;
    }
  });
}

var IonSelectOption = SelectOption;
var defineCustomElement = defineCustomElement$1;
export { IonSelectOption, defineCustomElement };